import React from 'react';

const Loader = ({ 
  isLoading, 
  message = "Loading...", 
  size = "large",
  overlay = true 
}) => {
  if (!isLoading) return null;

  const sizeClasses = {
    small: 'h-8 w-8',
    medium: 'h-12 w-12',
    large: 'h-16 w-16'
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.large;

  if (overlay) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50 animate-fadeIn">
        <div className="bg-white rounded-lg p-6 shadow-xl flex flex-col items-center space-y-4 min-w-[200px]">
          <div className={`animate-spin rounded-full border-4 border-gray-200 border-t-orange-600 ${spinnerSize}`}></div>
          <p className="text-gray-700 font-medium">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <div className="flex flex-col items-center space-y-2">
        <div className={`animate-spin rounded-full border-4 border-gray-200 border-t-orange-600 ${spinnerSize}`}></div>
        {message && <p className="text-gray-600 text-sm">{message}</p>}
      </div>
    </div>
  );
};

export default Loader;
